module.exports = __webpack_public_path__ + "static/media/C8.223d8240.png";